import { ResetIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Button } from '../../../primitives/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ButtonHistoryProps {
  editor: Editor;
}

export function ButtonHistory({ editor }: ButtonHistoryProps) {
  const { canRedo, canUndo } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor | null }) =>
      editor
        ? {
            canUndo: editor.can().chain().undo().run() ?? false,
            canRedo: editor.can().chain().redo().run() ?? false,
          }
        : { canRedo: false, canUndo: false },
  });

  return (
    <div className="flex gap-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              aria-label="Deshacer"
              disabled={!canUndo || !editor.isEditable}
              size="icon"
              variant="ghost"
              onClick={() => editor.chain().focus().undo().run()}
            >
              <ResetIcon className="size-4" />
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="flex flex-col">
            Deshacer <span className="text-accent">⌘Z</span>
          </p>
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <div>
            <Button
              aria-label="Rehacer"
              disabled={!canRedo || !editor.isEditable}
              size="icon"
              variant="ghost"
              onClick={() => editor.chain().focus().redo().run()}
            >
              <ResetIcon className="size-4 scale-x-[-1]" />
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="flex flex-col">
            Rehacer <span className="text-accent">⌘⇧Z</span>
          </p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
